@if ($attributeSetNode(); as attributeSetNode) {
    <cm-geometry-attribute-set-inspector [node]="attributeSetNode"></cm-geometry-attribute-set-inspector>
}
@if ($getAttributeSetLike(); as getAttributeSetLike) {
    <cm-inspector-section>
        <ng-container cm-content>
            <cm-value-slot [node]="getAttributeSetLike" [key]="'attributeSet'" [label]="'Attribute set'"></cm-value-slot>
            <cm-value-slot [node]="getAttributeSetLike" [key]="'attributeSetName'" [label]="'Attribute set name'"></cm-value-slot>
        </ng-container>
    </cm-inspector-section>
}
@if ($joinOperatorLike(); as joinOperatorLike) {
    <cm-inspector-section>
        <ng-container cm-content>
            <cm-value-slot [node]="joinOperatorLike" [key]="'primaryAttributeA'" [label]="'Primary attribute A'"></cm-value-slot>
            <cm-value-slot [node]="joinOperatorLike" [key]="'attributeSetA'" [label]="'Attribute set A'"></cm-value-slot>
            <cm-value-slot [node]="joinOperatorLike" [key]="'primaryAttributeB'" [label]="'Primary attribute B'"></cm-value-slot>
            <cm-value-slot [node]="joinOperatorLike" [key]="'attributeSetB'" [label]="'Attribute set B'"></cm-value-slot>
        </ng-container>
    </cm-inspector-section>
    @if ($joinOperatorLikeOutputSetA(); as joinOperatorLikeOutputSetA) {
        @if ($joinOperatorLikeOutputSetB(); as joinOperatorLikeOutputSetB) {
            <div class="cm-section-divider"></div>
            <cm-inspector-section>
                <ng-container cm-content>
                    <cm-value-slot [node]="joinOperatorLikeOutputSetA" [key]="'output'" [label]="'Joined attribute set A'"></cm-value-slot>
                    <cm-value-slot [node]="joinOperatorLikeOutputSetB" [key]="'output'" [label]="'Joined attribute set B'"></cm-value-slot>
                </ng-container>
            </cm-inspector-section>
        }
    }
}
@if ($triangulateOperatorLike(); as triangulateOperatorLike) {
    <cm-inspector-section>
        <ng-container cm-content>
            <cm-value-slot [node]="triangulateOperatorLike" [key]="'primaryAttribute'" [label]="'Primary attribute'"></cm-value-slot>
            <cm-value-slot [node]="triangulateOperatorLike" [key]="'attributeSet'" [label]="'Attribute set'"></cm-value-slot>
        </ng-container>
    </cm-inspector-section>
}
@if ($productOperatorLike(); as productOperatorLike) {
    <cm-inspector-section>
        <ng-container cm-content>
            @if ($productOperatorOperatorParameterSelectionPossibilities(); as productOperatorOperatorParameterSelectionPossibilities) {
                <cm-value-slot
                    #productOperatorOperatorParameterSelection
                    [node]="productOperatorOperatorParameterSelectionPossibilities.node"
                    [key]="'inputClass'"
                    [label]="'Input'"
                    [selectionPossibilities]="productOperatorOperatorParameterSelectionPossibilities.possibilities"
                    (onChanged)="onProductOperatorOperatorParameterSelectionChange($event)"
                ></cm-value-slot>
            }
            @if ($productOperatorLikeOperatorParameter(); as productOperatorLikeOperatorParameter) {
                <cm-value-slot [node]="productOperatorLikeOperatorParameter" [key]="'primaryAttributeA'" [label]="'Primary attribute A'"></cm-value-slot>
                <cm-value-slot [node]="productOperatorLikeOperatorParameter" [key]="'attributeSetA'" [label]="'Attribute set A'"></cm-value-slot>
                <cm-value-slot [node]="productOperatorLikeOperatorParameter" [key]="'primaryAttributeB'" [label]="'Primary attribute B'"></cm-value-slot>
                <cm-value-slot [node]="productOperatorLikeOperatorParameter" [key]="'attributeSetB'" [label]="'Attribute set B'"></cm-value-slot>
            }
        </ng-container>
    </cm-inspector-section>
    @if ($productOperatorLikeOutputSetA(); as productOperatorLikeOutputSetA) {
        @if ($productOperatorLikeOutputSetB(); as productOperatorLikeOutputSetB) {
            <div class="cm-section-divider"></div>
            <cm-inspector-section>
                <ng-container cm-content>
                    <cm-value-slot [node]="productOperatorLikeOutputSetA" [key]="'output'" [label]="'Product attribute set A'"></cm-value-slot>
                    <cm-value-slot [node]="productOperatorLikeOutputSetB" [key]="'output'" [label]="'Product attribute set B'"></cm-value-slot>
                </ng-container>
            </cm-inspector-section>
        }
    }
}
@if ($projectOperatorLike(); as projectOperatorLike) {
    <cm-inspector-section>
        <ng-container cm-content>
            <cm-value-slot [node]="projectOperatorLike" [key]="'sourceAttribute'" [label]="'Source attribute'"></cm-value-slot>
            <cm-value-slot [node]="projectOperatorLike" [key]="'targetAttribute'" [label]="'Target attribute'"></cm-value-slot>
            <cm-value-slot [node]="projectOperatorLike" [key]="'targetAttributeSet'" [label]="'Target attribute set'"></cm-value-slot>
        </ng-container>
    </cm-inspector-section>
}
@if ($cutOperatorLike(); as cutOperatorLike) {
    <cm-inspector-section>
        <ng-container cm-content>
            <cm-value-slot [node]="cutOperatorLike" [key]="'meshUVAttribute'" [label]="'Mesh UV attribute'"></cm-value-slot>
            <cm-value-slot [node]="cutOperatorLike" [key]="'meshAttributeSet'" [label]="'Mesh attribute set'"></cm-value-slot>
            <cm-value-slot [node]="cutOperatorLike" [key]="'curveUVAttribute'" [label]="'Curve UV attribute'"></cm-value-slot>
            <cm-value-slot [node]="cutOperatorLike" [key]="'curveGroupIDAttribute'" [label]="'Curve Group ID attribute'"></cm-value-slot>
            <cm-value-slot [node]="cutOperatorLike" [key]="'groupIDs'" [label]="'Group IDs'"></cm-value-slot>
        </ng-container>
    </cm-inspector-section>
    @if ($cutOperatorLikeCutMeshAttributeSetOutput(); as cutOperatorLikeCutMeshAttributeSetOutput) {
        @if ($cutOperatorLikeWindingAttributeSetOutput(); as cutOperatorLikeWindingAttributeSetOutput) {
            <div class="cm-section-divider"></div>
            <cm-inspector-section>
                <ng-container cm-content>
                    <cm-value-slot [node]="cutOperatorLikeCutMeshAttributeSetOutput" [key]="'cutMeshAttributeSet'" [label]="'Cut mesh attribute set'">
                    </cm-value-slot>
                    <cm-value-slot [node]="cutOperatorLikeWindingAttributeSetOutput" [key]="'windingAttributeSet'" [label]="'Winding attribute set'">
                    </cm-value-slot>
                </ng-container>
            </cm-inspector-section>
        }
    }
}
@if ($filterOperatorLike(); as filterOperatorLike) {
    <cm-inspector-section>
        <ng-container cm-content>
            <cm-value-slot [node]="filterOperatorLike" [key]="'primaryAttribute'" [label]="'Primary attribute'"></cm-value-slot>
            <cm-value-slot [node]="filterOperatorLike" [key]="'attributeSet'" [label]="'Attribute set'"></cm-value-slot>
        </ng-container>
    </cm-inspector-section>
}
@if ($partitionOperatorLike(); as partitionOperatorLike) {
    <cm-inspector-section>
        <ng-container cm-content>
            <cm-value-slot [node]="partitionOperatorLike" [key]="'primaryAttribute'" [label]="'Primary attribute'"></cm-value-slot>
            <cm-value-slot [node]="partitionOperatorLike" [key]="'attributeSet'" [label]="'Attribute set'"></cm-value-slot>
        </ng-container>
    </cm-inspector-section>
    @if ($partitionOperatorLikeOutputSetA(); as partitionOperatorLikeOutputSetA) {
        @if ($partitionOperatorLikeOutputSetB(); as partitionOperatorLikeOutputSetB) {
            <div class="cm-section-divider"></div>
            <cm-inspector-section>
                <ng-container cm-content>
                    <cm-value-slot [node]="partitionOperatorLikeOutputSetA" [key]="'output'" [label]="'Part A'"></cm-value-slot>
                    <cm-value-slot [node]="partitionOperatorLikeOutputSetB" [key]="'output'" [label]="'Part B'"></cm-value-slot>
                </ng-container>
            </cm-inspector-section>
        }
    }
}
@if ($flipOperatorLike(); as flipOperatorLike) {
    <cm-inspector-section>
        <ng-container cm-content>
            <cm-value-slot [node]="flipOperatorLike" [key]="'attributeSet'" [label]="'Attribute set'"></cm-value-slot>
        </ng-container>
    </cm-inspector-section>
}
@if ($boundaryOperatorLike(); as boundaryOperatorLike) {
    <cm-inspector-section>
        <ng-container cm-content>
            <cm-value-slot [node]="boundaryOperatorLike" [key]="'primaryAttribute'" [label]="'Primary attribute'"></cm-value-slot>
            <cm-value-slot [node]="boundaryOperatorLike" [key]="'attributeSet'" [label]="'Attribute set'"></cm-value-slot>
        </ng-container>
    </cm-inspector-section>
}
@if ($mergeOperatorLike(); as mergeOperatorLike) {
    <cm-inspector-section>
        <ng-container cm-content>
            <cm-value-slot [node]="mergeOperatorLike" [key]="'attributeSets'" [label]="'Attribute sets'"></cm-value-slot>
        </ng-container>
    </cm-inspector-section>
}
@if ($splitOperatorLike(); as splitOperatorLike) {
    <cm-inspector-section>
        <ng-container cm-content>
            <cm-value-slot [node]="splitOperatorLike" [key]="'primaryAttribute'" [label]="'Primary attribute'"></cm-value-slot>
            <cm-value-slot [node]="splitOperatorLike" [key]="'attributeSet'" [label]="'Attribute set'"></cm-value-slot>
            <cm-value-slot [node]="splitOperatorLike" [key]="'count'" [label]="'Count'"></cm-value-slot>
        </ng-container>
    </cm-inspector-section>
}
@if ($subdivideOperatorLike(); as subdivideOperatorLike) {
    <cm-inspector-section>
        <ng-container cm-content>
            <cm-value-slot [node]="subdivideOperatorLike" [key]="'subdivisionLevel'" [label]="'Subdivision level'"></cm-value-slot>
            <cm-value-slot [node]="subdivideOperatorLike" [key]="'positionAttribute'" [label]="'Position attribute'"></cm-value-slot>
            <cm-value-slot [node]="subdivideOperatorLike" [key]="'vertexVaryingAttributes'" [label]="'Vertex varying attributes'"> </cm-value-slot>
            <cm-value-slot [node]="subdivideOperatorLike" [key]="'primitiveUniformAttributes'" [label]="'Primitive uniform attributes'"> </cm-value-slot>
        </ng-container>
    </cm-inspector-section>

    @if ($subdivideOperatorLikePositionAttributeOutput(); as subdivideOperatorLikePositionAttributeOutput) {
        @if ($subdivideOperatorLikeNormalAttributeOutput(); as subdivideOperatorLikeNormalAttributeOutput) {
            @if ($subdivideOperatorLikeVertexVaryingAttributesOutput(); as subdivideOperatorLikeVertexVaryingAttributesOutput) {
                @if ($subdivideOperatorLikePrimitiveUniformAttributesOutput(); as subdivideOperatorLikePrimitiveUniformAttributesOutput) {
                    <div class="cm-section-divider"></div>
                    <cm-inspector-section>
                        <ng-container cm-content>
                            <cm-value-slot
                                [node]="subdivideOperatorLikePositionAttributeOutput"
                                [key]="'output'"
                                [label]="'Position attribute'"
                            ></cm-value-slot>
                            <cm-value-slot [node]="subdivideOperatorLikeNormalAttributeOutput" [key]="'output'" [label]="'Normal attribute'"></cm-value-slot>
                            <cm-value-slot
                                [node]="subdivideOperatorLikeVertexVaryingAttributesOutput"
                                [key]="'output'"
                                [label]="'Vertex varying attributes'"
                            ></cm-value-slot>
                            <cm-value-slot
                                [node]="subdivideOperatorLikePrimitiveUniformAttributesOutput"
                                [key]="'output'"
                                [label]="'Primitive uniform attributes'"
                            ></cm-value-slot>
                        </ng-container>
                    </cm-inspector-section>
                }
            }
        }
    }
}
